const _excluded = ["onClick", "disabled", "renderIcon", "style"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import React from 'react';
import PropTypes from 'prop-types';
import Button from '@adsk/alloy-react-button';
import theme, { stylePropType } from '@adsk/alloy-react-theme';
const PaginationButton = _ref => {
  let {
      onClick,
      disabled,
      renderIcon,
      style
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement(Button, _extends({
    onClick: onClick,
    disabled: disabled,
    variant: Button.VARIANTS.TERTIARY,
    size: Button.SIZES.SMALL,
    style: [{
      color: disabled ? theme.tokens.colors.icon.inactive.value : theme.tokens.colors.icon.primary.value,
      padding: 0,
      pointerEvents: disabled ? 'none' : 'inherit'
    }, style]
  }, props), renderIcon === null || renderIcon === void 0 ? void 0 : renderIcon({
    size: 20
  }));
};
PaginationButton.propTypes = {
  onClick: PropTypes.func,
  disabled: PropTypes.bool,
  renderIcon: PropTypes.func.isRequired,
  style: stylePropType
};
export default PaginationButton;
//# sourceMappingURL=PaginationButton.js.map